var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_54",
    d: "M5.713,1.006a1,1,0,0,1,1.575,0l.92,1.176a1,1,0,0,0,.784.384l1.482,0a1,1,0,0,1,.973,1.214l-.338,1.542a1,1,0,0,0,.185.825L12.256,7.4A1,1,0,0,1,11.91,8.9l-1.369.682a1,1,0,0,0-.53.675l-.34,1.506a1,1,0,0,1-1.415.678L6.94,11.8a1,1,0,0,0-.88,0l-1.316.645a1,1,0,0,1-1.415-.678l-.34-1.506a1,1,0,0,0-.53-.675L1.09,8.9A1,1,0,0,1,.744,7.4l.961-1.244a1,1,0,0,0,.185-.825L1.553,3.785a1,1,0,0,1,.973-1.214l1.482,0a1,1,0,0,0,.784-.384Z",
    fill: "#1f81c1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPartner);
export default __webpack_public_path__ + "static/media/main-partner.73b7483c.svg";
export { ForwardRef as ReactComponent };